<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="fm01">
<header><h1 class="htitle" id="fm01"><span aria-label=" Page ix. " epub:type="pagebreak" id="page_ix" role="doc-pagebreak">ALSO BY JEREMY LENT</span></h1></header>
<p class="center1"><i>The Patterning Instinct</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?dbd30472